/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductsTraceabilityQueryResponse,
  FindProductsTraceabilityQueryParams,
} from "../types/FindProductsTraceability.ts"

export const findProductsTraceabilityQueryKey = (
  params: FindProductsTraceabilityQueryParams
) =>
  [
    { url: "/v1/product/find-products-traceability" },
    ...(params ? [params] : []),
  ] as const

export type FindProductsTraceabilityQueryKey = ReturnType<
  typeof findProductsTraceabilityQueryKey
>

/**
 * @summary Find products traceability
 * {@link /v1/product/find-products-traceability}
 */
export async function findProductsTraceability(
  params: FindProductsTraceabilityQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductsTraceabilityQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-products-traceability`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductsTraceabilityQueryOptions(
  params: FindProductsTraceabilityQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductsTraceabilityQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductsTraceabilityQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductsTraceabilityQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductsTraceability(params, config)
    },
  })
}

/**
 * @summary Find products traceability
 * {@link /v1/product/find-products-traceability}
 */
export function useFindProductsTraceability<
  TData = ResponseConfig<FindProductsTraceabilityQueryResponse>,
  TQueryData = ResponseConfig<FindProductsTraceabilityQueryResponse>,
  TQueryKey extends QueryKey = FindProductsTraceabilityQueryKey,
>(
  params: FindProductsTraceabilityQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductsTraceabilityQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductsTraceabilityQueryKey(params)

  const query = useQuery(
    {
      ...findProductsTraceabilityQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
